import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useTheme } from '../../contexts/ThemeContext';
import { borders } from '../../design-system/tokens/borders';
import { animations } from '../../design-system/tokens/animations';
const spin = keyframes` from { transform: rotate(0deg); } to { transform: rotate(360deg); } `;
const SpinnerContainer = styled.div<{ size?: number }>`
  display: inline-block;
  width: ${props => props.size || 20}px;
  height: ${props => props.size || 20}px;
  border: ${borders.width.thick} solid ${props => props.theme.colors.border};
  border-radius: ${borders.radius.full};
  border-top-color: ${props => props.theme.colors.primary};
  animation: ${spin} ${animations.duration.slow}ms ${animations.easing.linear}
    infinite;
`;
const FullPageSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background: ${props => props.theme.colors.background};
`;

type LoadingSpinnerSize = number | 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface LoadingSpinnerProps {
  size?: LoadingSpinnerSize;
  fullPage?: boolean;
}

const getSizeInPixels = (size?: LoadingSpinnerSize): number => {
  if (typeof size === 'number') {
    return size;
  }
  const sizeMap: Record<string, number> = {
    xs: 12,
    sm: 16,
    md: 20,
    lg: 24,
    xl: 32,
  };
  return sizeMap[size || 'md'] || 20;
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size,
  fullPage,
}) => {
  const theme = useTheme();
  const sizeInPixels = getSizeInPixels(size);
  
  if (fullPage) {
    return (
      <FullPageSpinner>
        <SpinnerContainer size={sizeInPixels} />
      </FullPageSpinner>
    );
  }
  return <SpinnerContainer size={sizeInPixels} />;
};
export default LoadingSpinner;
